import {
  MdOutlineEdit,
  MdOutlineHome,
  MdOutlineMap,
  MdOutlinePhone,
  MdOutlineWbSunny,
} from 'react-icons/md';

import PromotionFillIcon from '@/components/Icons/PromotionFill';

const iconClassName = 'size-5 shrink-0';

export function getNavIcon(id: string) {
  const className = `${iconClassName} text-graphite`;

  switch (id) {
    case 'villas-in-sicily':
    case 'villas-in-puglia':
      return <MdOutlineHome className={className} />;
    case 'experiences':
      return <MdOutlineWbSunny className={className} />;
    case 'guides':
      return <MdOutlineMap className={className} />;
    case 'blog':
      return <MdOutlineEdit className={className} />;
    case 'contacts':
      return <MdOutlinePhone className={className} />;
    case 'offers':
      return (
        <PromotionFillIcon
          className={`${className} !text-primary fill-current`}
        />
      );
    default:
      return null;
  }
}
